<!-- 采购订单数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
            :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                    size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType != 2">

                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(
formOneValue, formOneKey
                        ) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1
                          ? [{ required: true, trigger: ['blur', 'change'] }]
                          : []
                          ">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                          v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <!-- 日期 -->
                        <df-date class="form_codition" v-if="formOneValue.entityField == 'psomBuydate'"
                          @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                          :isShowLong="false"
                          :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0)">
                        </df-date>
                        <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                          v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                          :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0)">
                        </df-date>
                        <!-- 检索方案 -->
                        <el-input class="form_codition" v-else-if="formOneValue.fieldType == 'search'" clearable
                          v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                          :id="formOneValue.entityField" @keyup.enter.native="
                            openSearch(
                              formOneValue.searchId,
                              formOneKey,
                              formOneValue.entityField,
                              formOneValue.setField
                            )"
                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0 && isTiQu)">
                          <el-button @click="
                            openSearch(
                              formOneValue.searchId,
                              formOneKey,
                              formOneValue.entityField,
                              formOneValue.setField
                            )
                            " slot="append" icon="el-icon-search"
                            :disabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0 && isTiQu) || dataActionBox.actionType == 2">
                          </el-button>
                        </el-input>
                        <!-- formatter下拉选   :automatic-dropdown="true"-->
                        <el-select class="form_codition" clearable size="mini"
                          v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0)"
                          @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                          <el-option v-for="item in JSON.parse(
                            formOneValue.formatterContent
                          )" :key="item.key" :label="item.key" :value="item.value">
                          </el-option>
                        </el-select>
                        <!-- 账期 -->
                        <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" type="number"
                          v-else-if="formOneValue.entityField == 'credit'"
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0)"
                          v-model="sendDataInfo[formOneValue.entityField]"
                          :maxlength="$store.state.inputLength"></el-input>
                        <!-- string类型 -->
                        <el-input class="form_codition" @keyup.enter.native="nextFocus(formOneKey)" v-else
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.sladjustdetails.length > 0 && formOneValue.isUpdate == 0)"
                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                          :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(
formOneValue, formOneKey
                        ) in scope.row.jurconfigform" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                          v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="
                            toDetail(sendDataInfo[formOneValue.riftField])
                            ">{{ sendDataInfo[formOneValue.entityField] }}</a>
                        </span>
                        <span v-else-if="formOneValue.fieldType == 'date'">
                          <span v-if="sendDataInfo[formOneValue.entityField]">
                            {{
                              $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                            }}
                          </span>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                          sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"
                        }}</span>
                        <span v-else>{{
                          sendDataInfo[formOneValue.entityField]
                        }}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div>
                    <el-form :inline="true" size="mini">
                      <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                        <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                          新增</el-button>
                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                        </el-button>
                        <el-button type="primary" size="mini" @click="copyDetails()">复制
                        </el-button>
                        <el-link :underline="false" type="danger" style="margin-left: 10px">
                          (Alt+F1：新增明细</el-link>
                        <el-link :underline="false" type="danger" style="margin-left: 10px">
                          Alt+F2：删除明细)</el-link>
                      </div>
                      <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef"
                        :data="sendDataInfo.sladjustdetails" :row-class-name="rowClassName" :row-style="rowStyle"
                        @row-click="clickEvent" @selection-change="handleSelectionChange" border style="width: 100%"
                        :height="mxHeight">
                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField"
                          show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(
formOneValue, formOneKey
                          ) in mxForm.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1">
                          <template slot-scope="scope">
                            <el-input v-if="formOneValue.fieldType == 'search' &&
                              dataActionBox.actionType != 2
                              && formOneValue.isChange == 1
                            " clearable v-model="sendDataInfo.sladjustdetails[scope.$index][formOneValue.entityField]"
                              :ref="formOneValue.entityField" :id="formOneValue.entityField"
                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 && formOneValue.isChange == 1">
                              <el-button @click="
                                openSearch(
                                  formOneValue.searchId,
                                  scope.$index,
                                  formOneValue.entityField,
                                  formOneValue.setField,
                                  formOneValue.focusField,
                                  true
                                )
                                " slot="append" icon="el-icon-search"
                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                              </el-button>
                            </el-input>
                            <!-- 移位数量 -->
                            <el-input @keyup.enter.native="
                              tableNextFocus(
                                formOneValue.focusField,
                                scope.$index
                              )
                              " @input="calculateNum(5, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'movdNum' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                              :maxlength="$store.state.inputLength" type="number"
                              v-model="sendDataInfo.sladjustdetails[scope.$index][formOneValue.entityField]">
                            </el-input>
                            <span v-else-if="formOneValue.isRift == 1">
                              <a @click="
                                toDetail(
                                  sendDataInfo.sladjustdetails[scope.$index][
                                  formOneValue.riftField
                                  ]
                                )
                                ">
                                {{
                                  sendDataInfo.sladjustdetails[scope.$index][
                                  formOneValue.entityField
                                  ]
                                }}</a>
                            </span>
                            <span v-else-if="formOneValue.fieldType == 'date'">{{
                              $common.getLocalTime(sendDataInfo.sladjustdetails[scope.$index][
                                formOneValue.entityField
                              ]) }}</span>
                            <span v-else>{{
                              sendDataInfo.sladjustdetails[scope.$index][
                              formOneValue.entityField
                              ]
                            }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
              @click="showPrintPlan">打印
            </el-button>
            <el-button v-if="dataActionBox.actionType != 2" type="primary"
              @click="initActionBox('sendDataInfo', 'pisOrderAuxinf')">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')"
              v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo', 'pisOrderAuxinf')"
              v-if="dataActionBox.actionType == 1">保存</el-button>
          </div>
          <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
              <el-button type="success">{{
                sendDataInfo[itemV.entityField]
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true"
      :append-to-body="true">
      <el-table :data="dialogList" border style="width: 100%">
        <el-table-column prop="level" label="类型" width="50">
          <template slot-scope="{row}">
            <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
              {{ row.level == 0 ? "拦截" : '预警' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="data" label="内容" min-width="180">
        </el-table-column>
        <el-table-column prop="validity" label="有效期" min-width="100">
          <template slot-scope="{row}">
            {{ $common.getLocalTime(row.validity) }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="提示" v-if="showDialog1" :visible.sync="showDialog1" width="70%" :modal-append-to-body="true"
          :append-to-body="true">
          <el-table :data="dialogList" border style="width: 100%">
              <el-table-column prop="level" label="类型" width="50">
                  <template slot-scope="{row}">
                      <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                          {{ row.level == 0 ? "拦截" : '预警' }}
                      </span>
                  </template>
              </el-table-column>
              <el-table-column prop="data" label="内容" min-width="180">
              </el-table-column>
              <el-table-column prop="validity" label="有效期" min-width="100">
                  <template slot-scope="{row}">
                      {{ $common.getLocalTime(row.validity) }}
                  </template>
              </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
              <el-button size="mini" type="primary" @click="intercept">确 定</el-button>
          </span>
      </el-dialog> -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
      :modal-append-to-body='true' :append-to-body="true">
      <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth"
        @sendTitle="getExtractName" />
    </el-dialog>
    <historicalOrders ref="HistoricalOrders" />
    <component :is="currentComponent" :ref="currentComponent"></component>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
  name: "slAdjustListAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    ExtractionScheme,
  },
  data() {
    //这里存放数据
    return {
      currentComponent: "",
      showDialog: false,
      showDialog1: false,
      flags: false,
      flag: -1,
      blurData: "",
      dialogList: [],
      mxHeight: 0,
      guaranteeBeginDay: "",
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDetailsIndex: 0,
      value1: "",
      sendDataInfo: {
      },
      showTabs: "",
      formDataList: [],
      dictionariesData: {},
      userOneList: [],
      goodsList: [],
      storageRoomList: [],
      salesmanList: [],
      editDateilsIndex: "",
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      ppId: "orderId",
      DialogVisible: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: "",
      smId: "",
      parentSearchData: {


      },
      isLoaded: false,
      orderId: "",
      printsouce: "",
      seIndex: 0, //选中索引
      isBuyer: 0,
      tabForm: [], // tab循环的主表单
      sField: "", // 赋值字段
      fField: "", //焦点字段
      nosField: "", // 不可赋值字段
      mxForm: [],
      footForm: [],
      selectedRow: [],
      isTiQu: true,
      detailsFlag: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.sladjustdetails": {
      handler: function (newValue, oldValue) {



        this.sendDataInfo.totalMoney = 0;
        this.sendDataInfo.totalNumber = 0;
        this.sendDataInfo.totalCount = 0;
        newValue.forEach((item, keys) => {
          console.log("///////", item)
          for (let key in item) {
            if (item[key] == null || item[key] == 'null') {
              this.sendDataInfo.sladjustdetails[keys][key] = ''
            }
          }
          let a = item.movdNum;
          if (item.movdNum == "") {
            item.movdNum = 0;
          } else if (a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
            item.movdNum = a.substring(1, a.length);
          }
          let b = item.psprice;
          if (item.psprice == "") {
            item.psprice = 0;
          } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
            item.psprice = b.substring(1, b.length);
          }
          if (item.psodPacknum < 0) {
            this.sendDataInfo["sladjustdetails"][keys].psodPacknum = 0;
            return false;
          }
          if (item.price < 0) {
            this.sendDataInfo["sladjustdetails"][keys].price = 0;
            return false;
          }
          if (item.money < 0) {
            this.sendDataInfo["sladjustdetails"][keys].money = 0;
            return false;
          }
          if (item.psprice < 0) {
            this.sendDataInfo["sladjustdetails"][keys].psprice = 0;
            return false;
          }
          if (item.psmoney < 0) {
            this.sendDataInfo["sladjustdetails"][keys].psmoney = 0;
            return false;
          }
          this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
            3,
            NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
          );
          this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
            1,
            NP.plus(this.sendDataInfo.totalNumber, item.movdNum)
          );
        });
        console.log("******")
        this.sendDataInfo.totalCount = newValue.length;

      },
      deep: true,
    },


  },
  //方法集合
  methods: {
    calculateNum(num, index) {
      if (Number(this.sendDataInfo.sladjustdetails[index].movdNum) > Number(this.sendDataInfo.sladjustdetails[index].stockNum)) {
        this.sendDataInfo.sladjustdetails[index].movdNum = 0
        return this.$message({
          message: "移位数量不能大于库存数量！",
          type: "warning",
        });
      }
      this.calculatePrice(num, index)
    },
    async blur(focusField, index, ownField, title) {
      return
      setTimeout(async () => {//失去焦点事件和点击事件冲突addDetail
        if (title == 'blur') {
          this.blurData = title
        } else {
          this.blurData = ''
        }
        if (this.flags) {
          this.flags = false
          return
        }
        this.fField = focusField
        this.seIndex = index
        this.seType = ownField
        let params = {
          "formId": this.formDataList[1].jciId,
          "num": '',
          "psprice": ''
        }
        if (ownField == 'psodPacknum') {
          params.num = this.sendDataInfo.sladjustdetails[index][ownField]
        } else if (ownField == 'psprice') {
          params.psprice = this.sendDataInfo.sladjustdetails[index][ownField]
        }
        if (ownField) {
          await this.$http.interceptPuNumPsPrice(params).then(res => {
            this.flag = -1
            if (res.result != null && res.result.length > 0) {
              this.dialogList = res.result
              this.flag = this.dialogList.findIndex(item => item.level == 0)
            } else {
              console.log(this.sendDataInfo.sladjustdetails[index][ownField]);
              if (this.sendDataInfo.sladjustdetails[index][ownField] != 0) {
                this.tableNextFocus(this.fField, this.seIndex);
              }
            }
            if (this.flag == 0) this.showDialog1 = true
            if (this.flag != -1) {
              this.$nextTick(() => {
                // document.getElementById("qrBtn")?.focus();
                if (title != 'blur') {
                  this.flags = true
                }
                this.sendDataInfo.sladjustdetails[index][ownField] = 0
                this.$refs[ownField][index].blur()
              })
            }
          })

        }
      }, 150)
    },
    intercept() {
      this.showDialog1 = false
      if (this.flag == -1) {
        this.tableNextFocus(this.fField, this.seIndex);
      } else {
        this.$nextTick(() => {
          this.$refs[this.seType][this.seIndex].focus()
        })
      }
    },
    Historical(url, title) {
      this.currentComponent = url
      var historicalOrder = {
        smName: "",
        smId: "",
        bgmName: "",
        bgmId: "",
      }
      if (this.currentComponent == 'historicalOrders') {
        historicalOrder.smName = this.sendDataInfo['smName']
        historicalOrder.smId = this.sendDataInfo['smId']
      }
      if (this.sendDataInfo['sladjustdetails'].length > 0) {
        historicalOrder.bgmId = this.sendDataInfo['sladjustdetails'][this.selectedDetailsIndex].bgmId
        historicalOrder.bgmName = this.sendDataInfo['sladjustdetails'][this.selectedDetailsIndex].bgmName
      }
      this.$nextTick(() => {
        this.$refs[this.currentComponent].openBox(historicalOrder, title)
      })
    },
    //触发提取
    openExtSearch(id) {
      if (id == '629899519725569') {
        this.ppId = 'orderId'
      } else if (id == '949599709200712') {
        this.ppId = 'conmId'
      } else if (id == '538560780537856') {
        this.ppId = 'pmId'
      }
      this.exId = id;
      this.DialogExtract = true;
    },
    //提取返回
    async getDataByChen(val) {
      console.log(val)

      if (val != "" || val != undefined) {
        this.$http
          .checkVendorLicense({
            //校验购进单位
            formId: this.formDataList[0].jciId, //表单ID
            unitId: val.smId || '', //单位ID
          })
          .then((res) => {

            if (res && res.status == 200) {
              let flag = -1
              if (res.result != null && res.result.length > 0) {
                this.dialogList = res.result
                flag = this.dialogList.findIndex(item => item.level == 0)
                this.showDialog = true
              }

              if (flag == -1) {
                for (let key in val) {
                  if (key == "arrlistbychen") {
                    this.sendDataInfo.sladjustdetails = val.arrlistbychen;
                  } else {
                    console.log(key);

                    this.sendDataInfo[key] = val[key];
                    this.sendDataInfo.totalMoney = 0
                    this.sendDataInfo.totalNumber = 0
                    this.sendDataInfo.totalCount = 0
                  }
                }
                this.sendDataInfo.sladjustdetails.forEach((item, index) => {
                  this.sendDataInfo.totalMoney += item.rrdPsmoney
                  this.sendDataInfo.totalNumber += item.oldNum
                  this.calculatePrice(5, index)
                })
                this.parentSearchData.smId = val.smId
                this.sendDataInfo.totalCount = this.sendDataInfo.sladjustdetails.length
                this.isTiQu = false
                // 
                // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
                // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
                this.DialogExtract = false;

                this.$nextTick(() => {
                  this.selectedDetailsIndex = 0
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.sladjustdetails[this
                    .selectedDetailsIndex]);
                  this.nextFocus(0)
                })
              } else {
                this.showDialog = true
              }
            }
          })

      }
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 查看证照
    lookLicence() {
      if (this.sendDataInfo.smId == "") {
        return this.$message({
          message: "请先选择供货单位",
          type: "warning",
        });
      }
      this.$parent.$parent.toDetail(this.sendDataInfo.smId);
    },
    closeChild() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },
    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },
    // 表格方法
    rowClassName({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= this.inputel.length - 1) {
        if (this.sendDataInfo.sladjustdetails.length > 0) { }
        this.addDetail("sendDataInfo");
        return;
      }
      var aindex = index + 1;
      if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
        this.nextFocus(aindex);
        return;
      }
      this.inputel[aindex].focus();
    },

    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },

    // 表格切换焦点方法
    tableNextFocus(field, index) {
      if (field == "keydown") {
        this.addDetail("sendDataInfo");
        if (this.sendDataInfo.sladjustdetails[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          return;
        }
        // if(this.blurData != 'blur'){
        //     this.addDetail("sendDataInfo");
        // }

        return;
      }
      this.$refs[field][index].focus();
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        console.log("选中的数据", this.actionData);
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    toDetail(orderId) {
      // console.log(this.$parent.$parent.$parent);
      this.$parent.$parent.$parent.toDetail(orderId);
    },
    //换行提示
    lineMessageBox(data) {
      let txtArr = data.message.split("<br/>");
      let newArr = [];
      const h = this.$createElement;
      for (const i in txtArr) {
        newArr.push(h("p", null, txtArr[i]));
      }
      this.$alert(h("div", null, newArr), "提示", {
        confirmButtonText: "确定",
        callback: (action) => { },
      });
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item];
      });
      this.$nextTick(() => {
        this.nextFocus(this.seIndex);
      });
    },
    // 表格赋值字段
    mxParamValue(val) {
      if (this.sendDataInfo.sladjustdetails[this.seIndex].outSlid == val.inSlid && this.detailsFlag) {
        this.$message({
          message: "移入库位不能等于移出库位！",
          type: "error",
        });
        console.log(this.sField, "**********55555")
        this.tableNextFocus('inSlcode', this.seIndex);
        return
      }
      this.$nextTick(() => {

        let arr = this.sField.split(",");
        arr.forEach((item) => {
          if (this.detailsFlag) {
            this.sendDataInfo.sladjustdetails[this.seIndex][item] = val[item];
          } else {
            this.sendDataInfo[item] = val[item];
          }
        });
        this.$nextTick(() => {
          this.tableNextFocus(this.fField, this.seIndex);
        });
      })
    },
    // 清除赋值字段数据
    clearValue() {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },
    //提取返回
    changeInputModel(val) {
      console.log("返回", val, this.seType);
      if (val != "" && val != undefined) {
        this.DialogVisible = false;
        addEventListener("keyup", this.keyUp); //创建监听键盘事件

        if (this.seType == "bgmName") {
          if (val.length > 0) {
            this.bgmSelect(val)
            return
          }
          for (let key in val) {
            this.sendDataInfo.sladjustdetails[this.seIndex][key] =
              val[key];
          }
          this.sendDataInfo.sladjustdetails[this.seIndex].psodPsdvolume =
            val.rjXl;
          this.sendDataInfo.sladjustdetails[this.seIndex].psodPsnvolume =
            val.stockNum;
          this.sendDataInfo.sladjustdetails[
            this.seIndex
          ].psodPsupperlimit = val.limdHighnum;
          this.sendDataInfo.sladjustdetails[
            this.seIndex
          ].psodPslowerlimit = val.limdLownum;
          this.sendDataInfo.sladjustdetails[
            this.seIndex
          ].psmoney = 0;
          this.sendDataInfo.sladjustdetails[
            this.seIndex
          ].money = 0

          // this.calculateNum(5,this.seIndex)
          if (!this.dialogList.length) {
            this.tableNextFocus(this.fField, this.seIndex);
          }
          return true
        } else {
          this.DialogVisible = false;
          this.mxParamValue(val)
        }

      }


    },
    bgmSelect(val) {
      if (this.sendDataInfo.sladjustdetails && this.sendDataInfo.sladjustdetails.length > 0) {
        var mx = JSON.parse(JSON.stringify(val))
        this.sendDataInfo.sladjustdetails.forEach((item, index) => {
          if (item.bgmId == '' || item.bgmName == '') {
            this.sendDataInfo.sladjustdetails.splice(index, 1)
          }
        })
        mx.forEach((item) => {
          this.sendDataInfo.sladjustdetails.push({})
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.sladjustdetails[this.sendDataInfo.sladjustdetails.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : '')
          }
        })
      } else {
        this.sendDataInfo.sladjustdetails = []
        val.forEach((item, index) => {
          this.sendDataInfo.sladjustdetails.push({})
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.sladjustdetails[index], key, item[key] != undefined && item[key] != null ? item[key] : '')
          }
        })
      }
      this.selectedDetailsIndex = this.sendDataInfo.sladjustdetails.length - 1
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, flag) {
      setTimeout(() => {
        this.showDialog = false
      }, 16.7)

      removeEventListener("keyup", this.keyUp);
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.fField = fField;
      if (flag) {
        this.detailsFlag = true
        this.parentSearchData[type] = this.sendDataInfo.sladjustdetails[this.seIndex][type];
        if (this.seType == 'inSlcode') {
          this.parentSearchData.slCode = this.sendDataInfo.sladjustdetails[this.seIndex][type];
        }
      } else {
        this.detailsFlag = false
        this.parentSearchData[type] = this.sendDataInfo[type];
      }
      this.DialogVisible = true;


    },
    tableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    //新增明细
    addDetail(sendDataInfo) {
      var flag = false
      if (this.sendDataInfo.sladjustdetails.length > 0) {
        this.sendDataInfo.sladjustdetails.forEach(item => {
          if (item.bgmId == "") {
            flag = true
            return this.$message({
              message: "请不要重复新增空白行",
              type: "warning",
            });
          }
        })
      }
      if (flag) {
        return
      }
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sendDataInfo.sladjustdetails.push({})
          var index = this.sendDataInfo.sladjustdetails.length - 1
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.sladjustdetails[index], key, this.detaislDataInfo[key])
          }
          this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
              this.sendDataInfo.sladjustdetails.length - 1
            );
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
            );
          });
        } else {
          return this.$message({
            message: "请完善必填信息",
            type: "warning",
          });
        }
      });
    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = "";
        return false;
      }

      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
      if (dataInfo.psodPacknum <= 0) {
        this.$message({
          message: "请填写采购数量",
          type: "error",
        });
        return false;
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.sladjustdetails.splice(this.editDateilsIndex, 1);
      }
      this.sendDataInfo.sladjustdetails.push(dataInfo);
      this.editDateilsIndex = "";
    },
    // 计算价格
    calculatePrice(cate, index) {
      var info = this.sendDataInfo.sladjustdetails[index];
      if (info.psodPacknum <= 0) {
        this.$message({
          message: "请先填写采购数量",
          type: "error",
        });
        return false;
      }
      switch (cate) {
        case 1: // 单价计算
          // 计算含税价格 单价+单价*税率/100
          var thisPrice = NP.plus(
            info.price,
            NP.divide(NP.times(info.price, info.inRate), 100)
          );
          this.sendDataInfo.sladjustdetails[index].psprice =
            this.$common.getDecimalInfo(2, thisPrice);
          // 计算金额 单价*数量
          this.sendDataInfo.sladjustdetails[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.price, info.psodPacknum)
            );
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.sladjustdetails[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.psodPacknum)
            );
          //计算税额
          this.sendDataInfo.sladjustdetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info
            .psmoney, info.money))
          break;
        case 2: // 含税价格计算
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.sladjustdetails[index].psmoney = info.psodPacknum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.psodPacknum));
          // 计算金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.sladjustdetails[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
          // var midmoney = NP.divide(this.sendDataInfo.sladjustdetails[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.sladjustdetails[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.sladjustdetails[index].price = info.psodPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.psodPacknum));
          //计算税额
          this.sendDataInfo.sladjustdetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.sladjustdetails[index].psmoney, this.sendDataInfo.sladjustdetails[index].money));
          break;
        case 3: // 通过总金额计算
          // 计算单价  总金额 / 数量
          var thisPrice = NP.divide(info.money, info.psodPacknum);
          this.sendDataInfo.sladjustdetails[index].price =
            this.$common.getDecimalInfo(2, thisPrice);
          // 计算含税价格 单价+单价*税率/100
          var thisPriceTwo = NP.plus(
            thisPrice,
            NP.divide(NP.times(thisPrice, info.inRate), 100)
          );
          this.sendDataInfo.sladjustdetails[index].psprice =
            this.$common.getDecimalInfo(3, thisPriceTwo);

          // 计算整件数量
          this.sendDataInfo.sladjustdetails[index].wholeNum = Math.floor(NP.divide(info.psodPacknum, Number(
            info.packingSpec)))

          //计算零散数量
          this.sendDataInfo.sladjustdetails[index].scatNum = info.psodPacknum - info.wholeNum * Number(info
            .packingSpec)

          //计算零散数量
          // this.sendDataInfo.sladjustdetails[index].scatNum = this.$common.getDecimalInfo(1, NP.minus(info.psodPacknum - NP.times(info.wholeNum, Number(info.packingSpec))))

          //计算税额
          this.sendDataInfo.sladjustdetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info
            .psmoney, info.money))
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.sladjustdetails[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.psodPacknum)
            );
          break;
        case 4: // 通过含税金额计算
          // 计算含税价格  含税金额 / 数量
          this.sendDataInfo.sladjustdetails[index].psprice = info.psodPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.psmoney, info.psodPacknum));
          // 计算总金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
          // var midmoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.sladjustdetails[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.sladjustdetails[index].price = info.psodPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.psodPacknum));
          //计算税额
          this.sendDataInfo.sladjustdetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, this.sendDataInfo.sladjustdetails[index].money));
          break;
        default:
          // 通过数量计算
          //计算零散数量
          // this.sendDataInfo.sladjustdetails[index].scatNum = info.psodPacknum - info.wholeNum * Number(info.packingSpec)
          // 计算含税金额 含税价格*移位数量
          var midmoney = info.movdNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.movdNum));
          var midmoney = info.movdNum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.movdNum));
          // var midmoney = info.psodPacknum === 0 ? 0 : NP.times(info.psprice, info.psodPacknum).toFixed(10);
          this.sendDataInfo.sladjustdetails[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
          // 计算总金额 含税金额/(税率/100+1)
          this.sendDataInfo.sladjustdetails[index].money = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.sladjustdetails[index].price, NP.plus(NP.divide(info.inRate, 100), 1)));
          // 计算整件数量
          this.sendDataInfo.sladjustdetails[index].wholeNum = Math.floor(NP.divide(info.movdNum, Number(info.packingSpec)));
          //计算零散数量
          this.sendDataInfo.sladjustdetails[index].scatNum = NP.minus(info.movdNum, NP.times(this.sendDataInfo.sladjustdetails[index].wholeNum, Number(info.packingSpec)));
          //计算税额
          this.sendDataInfo.sladjustdetails[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.sladjustdetails[index].psmoney, this.sendDataInfo.sladjustdetails[index].money));

          // 计算件数 采数/包装单位
          if ('packingSpec' in this.sendDataInfo.sladjustdetails[index] && 'pieceNum' in this.sendDataInfo.sladjustdetails[index]) {
            if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
              this.sendDataInfo.sladjustdetails[index].pieceNum = 0;
            } else {
              this.sendDataInfo.sladjustdetails[index].pieceNum =
                this.$common.getDecimalInfo(
                  1,
                  NP.divide(info.movdNum, info.packingSpec)
                );
            }
          }

          break;
      }
    },
    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", 0);
          // this.$parent.getDataList()
          this.init();
          this.$refs[sendDataInfo].resetFields();
        })
        .catch(() => { });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "pisOrderAuxinf") {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

      this.sendDataInfo.sladjustdetails = [];
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.totalCount = 0;
    },

    // 选择采购员
    selectUserOne(data) {
      data.forEach((item) => {
        if (item.opmId == this.sendDataInfo.opmId) {
          this.sendDataInfo.psomBusdept = item.depId;
        }
      });
    },

    changeFocus() {
      setTimeout(() => {
        var el = document.getElementById("mainInfo");
        var inel = el.getElementsByClassName("el-input__inner");
        for (let index = 0; index < inel.length; index++) {
          if (inel[index].value == "") {
            inel[index].focus();
            break;
          }
        }
      }, 500);
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      this.filterMainField();
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        this.parentSearchData.smId = "";
        this.initDefaultValue()
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }

        this.smId = dataInfo.smId;
        this.parentSearchData.smId = oldData.smId
        this.$nextTick(() => {
          this.selectedDetailsIndex = 0;
          setTimeout(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
            );
          }, 16.7)
        });
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.psomId)
            this.mxHeight = this.$common.getHeight()
          }
        }, 16.7)

      });
      this.changeFocus();
    },
    // 默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform
      arr.forEach(item => {
        if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
          this.sendDataInfo[item.entityField] = item.defaultValue
        }
      })

      this.sendDataInfo.slamDate = this.$moment().valueOf();

    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item));
          this.mxForm.jurconfigform.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1 || key.jurconfigform[index].entityField == 'sbiName' || key.jurconfigform[index].entityField == 'sbiNumber')
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "sladjustdetails" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
    },
    //确认新增
    sendDataAction(formName1) {
      let flag = false;
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          this.$message({
            message: "请完善主表单必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
    },
    async sub() {
      if (this.sendDataInfo.sladjustdetails.length < 1) {
        this.$message({
          message: "请添加明细",
          type: "error",
        });
        return;
      } else {
        this.sendDataInfo.sladjustdetails.forEach((item, index) => {
          if (item.bgmId == "") {
            this.sendDataInfo.sladjustdetails.splice(index, 1);
          }
        });
      }
      this.sendDataInfo.totalCount = this.sendDataInfo.sladjustdetails.length

      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.slAdjustListAdd(this.sendDataInfo);
      } else {
        var responseData = await this.$http.slAdjustListUpdate(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", 1);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    deleteDetails() {
      if (this.sendDataInfo.sladjustdetails.length < 1) {
        this.isTiQu = true
        return this.$message({
          message: "暂无可删除明细",
          type: "warning",
        });
        return false;
      }

      this.sendDataInfo.sladjustdetails.splice(this.selectedDetailsIndex, 1);
      if (this.sendDataInfo.sladjustdetails.length > 1) {
        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
      } else {
        this.selectedDetailsIndex = 0;
      }
      this.tableNextFocus("bgmName", this.selectedDetailsIndex);
      let refsElTable = this.$refs.mxTableRef;
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(
        this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
      );
    },
    // 复制
    copyDetails() {
      if (this.sendDataInfo.sladjustdetails.length < 1) {
        return this.$message({
          message: "暂无可复制明细",
          type: "warning",
        });
        return false;
      } else {
        this.sendDataInfo.sladjustdetails.push(
          JSON.parse(
            JSON.stringify(
              this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
            )
          )
        );
      }
    },

    // 判断是不是采购员
    checkIsBuyer() {
      if (this.dataActionBox.actionType != 0) return;
      let info = JSON.parse(sessionStorage.getItem("userInfo"));
      if (info.opmBuyer == 1) {
        this.isBuyer = 1;
        this.sendDataInfo.depName = info.depName;
        this.sendDataInfo.depId = info.depId;
        this.sendDataInfo.opmName = info.opmName;
        this.sendDataInfo.opmId = info.opmId;
      }
    },
    // 监听键盘事件
    keyUp(e) {
      if (e.key == "F1") {
        // 右键新增明细
        e.preventDefault();
        this.addDetail("sendDataInfo");
        return;
      } else if (e.key == "F2") {
        e.preventDefault();
        this.deleteDetails();
      } else if (e.keyCode == 40) {
        // 下键
        // 表格为空，不执行下方
        if (this.sendDataInfo.sladjustdetails.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 如果当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (
            this.selectedDetailsIndex ==
            this.sendDataInfo.sladjustdetails.length - 1
          ) {
            // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDetailsIndex = 0;
          } else {
            // 正常递增
            this.selectedDetailsIndex++;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      } else if (e.keyCode == 38) {
        // 上键
        if (this.sendDataInfo.sladjustdetails.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (this.selectedDetailsIndex == 0) {
            // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDetailsIndex =
              this.sendDataInfo.sladjustdetails.length - 1;
          } else {
            // 正常递减
            this.selectedDetailsIndex--;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.sladjustdetails[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.checkIsBuyer();
      this.isLoaded = true;
    });


  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    setTimeout(() => {
      this.getMainInput();
    }, 16.7)
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}

::v-deep .el-alert__content {
  width: 100%;
}
</style>